module.exports = __webpack_public_path__ + "img/banner_itemthr_downimg.3d8ba657.png";